// App configuration - single source of truth
export const APP_VERSION = "v3.0.175";
export const BUILD_DATE = "2026-09-18";
